import http from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { sendSkuUpgradeNotificationRpc } from '../../../../__generated__/chirp/com/hubspot/personalization/rpc/RequestsRpc';
import { sendTrialRequestNotificationRpc } from '../../../../__generated__/chirp/com/hubspot/personalization/rpc/RequestsRpc';
import { rpcClient } from '../../../rpcClient';
const ENDPOINT = `${getFullUrl('app-api')}/monetization/v3/request`;
export const sendRequestAdditionalSeatsNotification = ({
  apiName,
  requestedSeatType
}) => {
  const data = requestedSeatType ? {
    requestedSeatType
  } : {
    apiName
  };
  return http.post(`${ENDPOINT}/seat?sendAdminNotification=true`, {
    data
  });
};
export const sendRequestSKUNotification = apiName => rpcClient.call(sendSkuUpgradeNotificationRpc, {
  request: {
    apiName
  }
});
export const sendRequestTrialNotification = apiName => rpcClient.call(sendTrialRequestNotificationRpc, {
  request: {
    apiName
  }
});
export const sendRequestQuotePurchaseNotification = hub => {
  return http.post(`${ENDPOINT}/quote-purchase`, {
    data: {
      hub
    }
  });
};